import React, { useMemo, Fragment } from 'react';
import { useLocation } from 'react-router-dom';

import cn from 'classnames';
import PT from 'prop-types';
import Navbar from '../Navbar';
import TabNav from '../TabNav';
import Button from '../Button';
import ProfilePreview from '../ProfilePreview';

const Page = ({ props }) => {
  const { pathname } = useLocation();
  const { className, titleProps, navigation = {}, navbarProps, content } = props;

  const renderedNavigation = useMemo(() => {
    let result;

    switch (navigation.variant) {
      case 'tabs':
        result = <TabNav {...navigation.tabsProps} />;
        break;

      case 'text-and-button':
        result = (
          <Fragment>
            <p {...navigation.textProps} />
            <Button {...navigation.buttonProps} />
          </Fragment>
        );
        break;

      default:
        result = <div>{'Wrong navigation variant selected in <First/>'}</div>;
    }

    return result;
  }, [navigation.variant, navigation.tabsProps, navigation.textProps, navigation.buttonProps]);

  if (!navbarProps.points && !pathname.includes('builds')) return null;

  return (
    <div className="app">
      {navbarProps.points && <Navbar {...navbarProps} />}
      <div className={cn(className)}>
        <div className="app__header">
          <h1 className="h1 app__title">{titleProps.text}</h1>
          {navbarProps.points && <ProfilePreview />}
        </div>
        {renderedNavigation}
        <div className="app__content">{content}</div>
      </div>
    </div>
  );
};

Page.propTypes = {
  className: PT.string,
  titleProps: PT.string,
  navigation: PT.shape({
    variant: PT.oneOf(['tabs', 'text-and-button']),
    tabsProps: PT.shape(TabNav.propTypes),
    textProps: PT.string,
    buttonProps: PT.shape(Button.propTypes),
  }),
  content: PT.object,
};

export default Page;
